import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import "./header.css";

const Header = ({ onLogout }) => {
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  const handleLogoutClick = () => {
    setShowLogoutModal(true);
  };

  const handleConfirmLogout = () => {
    setShowLogoutModal(false);
    onLogout();
  };

  const handleCancelLogout = () => {
    setShowLogoutModal(false);
  };

  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-light bg-light px-3">
        <a className="navbar-brand d-flex align-items-center" href="/">
          {/* <img
            src="http://localhost:3001/static/media/falcon.fa3b1ec66baa6b31819e.png"
            alt="Logo"
            width="40"
            className="me-2"
          /> */}
          <span className="text-primary fw-bold fs-4">Lokchem</span>
        </a>

        <div className="ms-auto d-flex align-items-center">
          <div className="dropdown">
            <a
              className="nav-link dropdown-toggle d-flex align-items-center"
              href="#!"
              id="profileDropdown"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <img
                src="http://localhost:3001/static/media/3.b3477e97bffc3dc7e37d.jpg"
                alt="Profile"
                className="rounded-circle"
                width="40"
                height="40"
              />
            </a>
            <ul
              className="dropdown-menu dropdown-menu-end"
              aria-labelledby="profileDropdown"
            >
              <li>
                <button
                  className="dropdown-item"
                  type="button"
                  onClick={handleLogoutClick}
                >
                  Logout
                </button>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      {/* Logout Modal */}
      <Modal show={showLogoutModal} onHide={handleCancelLogout} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Logout</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to logout?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCancelLogout}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleConfirmLogout}>
            Logout
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Header;
